<template>
  <v-hover v-slot="{ hover }">
    <v-card
      color="grey lighten-5"
      class="overflow-hidden"
      @click="$emit('preview', mediaItem)"
    >
      <v-progress-linear
        v-if="mediaItem.upload && mediaItem.progress && mediaItem.progress > 0"
        color="primary"
        :value="mediaItem.progress"
      />
      <div style="height: 160px; position: relative">
        <v-img
          v-if="mediaItem.thumbnail_url"
          :src="mediaItem.thumbnail_url"
          height="160px"
          @contextmenu.prevent="onContextMenu"
        />
        <v-img
          v-else-if="mediaItem.mime_type.includes('image/')"
          :src="mediaItem.url"
          height="160px"
          @contextmenu.prevent="onContextMenu"
        />
        <video
          v-else-if="isVideo"
          height="160px"
          :src="mediaItem.url"
          @contextmenu.prevent="onContextMenu"
        />
        <div
          v-else
          style="height: 160px"
          class="d-flex align-center justify-center"
        >
          <v-icon x-large>
            fal {{ iconFromMimeType(mediaItem.mime_type) }}
          </v-icon>
        </div>
        <v-chip
          v-if="showAuthor && mediaItem.created_by_user"
          x-small
          color="white"
          style="position: absolute; bottom: 8px; right: 8px; opacity: 0.8"
        >
          {{ mediaItem.created_by_user.first_name }} {{ mediaItem.created_by_user.last_name }}
        </v-chip>
        <!--        <div-->
        <!--          v-if="showEventDetails && mediaItem.model_type === 'App\\Models\\Event'"-->
        <!--          style="position: absolute; bottom: 0; left: 0; right: 0; background-color: rgba(50, 50, 50, 0.8)"-->
        <!--          class="text-caption py-1 px-2"-->
        <!--          :class="[ eventTypes[mediaItem.model.event_type].color + '&#45;&#45;text' ]"-->
        <!--        >-->
        <!--          <v-row no-gutters>-->
        <!--            <v-col class="text-truncate">-->
        <!--              {{ mediaItem.model.title }}-->
        <!--            </v-col>-->
        <!--            <v-col cols="auto">-->
        <!--              {{ $dayjs(mediaItem.created_at).format('L') }}-->
        <!--            </v-col>-->
        <!--          </v-row>-->
        <!--        </div>-->
      </div>
      <v-divider />
      <div
        v-if="mediaItem.error"
        class="error--text caption pt-2 px-2"
      >
        {{ mediaItem.error }}
      </div>
      <div
        v-if="showEventDetails && mediaItem.model_type === 'App\\Models\\Event' && mediaItem.model"
        class="text-caption px-2 pt-1"
      >
        <v-row
          no-gutters
          align="center"
        >
          <v-col
            cols="auto"
            class="pr-2"
          >
            <v-avatar
              size="6px"
              :color="eventTypes[mediaItem.model.event_type].color"
            />
          </v-col>
          <v-col
            class="text-truncate"
            :class="[ eventTypes[mediaItem.model.event_type].color + '--text' ]"
          >
            {{ mediaItem.model.title }}
          </v-col>
          <v-col
            cols="auto"
            class="grey--text text--lighten-1"
          >
            {{ $dayjs(mediaItem.created_at).format('L') }}
          </v-col>
        </v-row>
      </div>
      <div
        v-if="showDate"
        class="text-caption px-2 pt-2 grey--text"
      >
        {{ $dayjs(mediaItem.created_at).format('LL') }}
      </div>
      <v-row no-gutters>
        <v-col class="text-truncate caption pa-2">
          {{ mediaItem.name }}
        </v-col>
        <v-col
          v-if="hover"
          cols="auto"
          class="px-2"
        >
          <v-btn
            v-if="canDelete"
            small
            icon
            @click.stop="$emit('delete', mediaItem)"
          >
            <v-icon small>
              fa-regular fa-trash
            </v-icon>
          </v-btn>
          <v-btn
            v-if="canDownload && (!isVideo || canDownloadVideo)"
            small
            icon
            :href="mediaItem.download_url"
            target="_blank"
            @click.stop
          >
            <v-icon small>
              fa-regular fa-download
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <div
        v-if="mediaItem.tags && mediaItem.tags.length > 0"
        class="px-2 pb-2"
        style="line-height: 16px; line-clamp:2; overflow: hidden; text-overflow: ellipsis"
      >
        <v-chip
          v-for="tag in (onlyFirstTag ? [mediaItem.tags[0]] : mediaItem.tags)"
          :key="tag.id + mediaItem.id"
          label
          x-small
          outlined
          color="grey"
          text-color="grey"
        >
          {{ tag.label }}
        </v-chip>
        <span
          v-if="mediaItem.tags.length > 1 && onlyFirstTag"
          class="ml-1 grey--text"
        >
          ...
        </span>
      </div>
    </v-card>
  </v-hover>
</template>
<script>
import { EventTypes } from '@/data/models'

export default {
  name: 'MediaGridItem',
  props: {
    mediaItem: {
      type: Object,
      required: true
    },
    showEventDetails: {
      type: Boolean,
      default: false
    },
    showAuthor: {
      type: Boolean,
      default: false
    },
    showDate: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: true
    },
    canDownloadVideo: {
      type: Boolean,
      default: true
    },
    canDownload: {
      type: Boolean,
      default: true
    },
    onlyFirstTag: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isVideo() {
      return this.mediaItem.mime_type.includes('video/') || ['mp4', 'webm', 'ogg', 'mov', 'avi', 'mkv', 'flv', 'wmv'].indexOf(this.mediaItem.extension) > -1
    }
  },
  created() {
    this.eventTypes = EventTypes
  },
  methods: {
    iconFromMimeType(mimeType) {
      const mapping = {
        // Media
        image: 'fa-file-image-o',
        audio: 'fa-file-audio-o',
        video: 'fa-file-video-o',
        // Documents
        'application/pdf': 'fa-file-pdf',
        'application/msword': 'fa-file-word',
        'application/vnd.ms-word': 'fa-file-word',
        'application/vnd.oasis.opendocument.text': 'fa-file-word',
        'application/vnd.openxmlformats-officedocument.wordprocessingml':
          'fa-file-word',
        'application/vnd.ms-excel': 'fa-file-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml':
          'fa-file-excel',
        'application/vnd.oasis.opendocument.spreadsheet': 'fa-file-excel',
        'application/vnd.ms-powerpoint': 'fa-file-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml':
          'fa-file-powerpoint',
        'application/vnd.oasis.opendocument.presentation': 'fa-file-powerpoint',
        'text/plain': 'fa-file-text',
        'text/html': 'fa-file-code',
        'application/json': 'fa-file-code',
        // Archives
        'application/gzip': 'fa-file-archive',
        'application/zip': 'fa-file-archive'
      }

      if (!mapping[mimeType]) return 'fa-file'

      return mapping[mimeType]
    },
    onContextMenu(e) {
      if (!this.canDownloadVideo && this.isVideo) {
        e.preventDefault()
        return
      }

      if (!this.canDownload) {
        e.preventDefault()
        return
      }

      return true
    }
  }
}
</script>
